"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconColors = exports.buttonColors = exports.FOCUS_BORDER_COLOR = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FOCUS_BORDER_COLOR = exports.FOCUS_BORDER_COLOR = '#66BFFF';

// Shared color values
var WHITE = '#fff';
var TRANSPARENT = 'transparent';
var DARK_TEXT = '#33373D';
var LIGHT_BORDER = '#BEC5D3';
var LIGHT_BG = '#DFE3EC';

// Shared state objects
var whiteOutlined = {
  text: DARK_TEXT,
  border: LIGHT_BORDER,
  background: WHITE
};
var whiteGhost = {
  text: DARK_TEXT,
  border: TRANSPARENT,
  background: TRANSPARENT
};
var successColor = {
  "default": {
    text: WHITE,
    border: '#28865E',
    background: '#28865E'
  },
  hover: {
    text: WHITE,
    border: '#206B4A',
    background: '#206B4A'
  },
  pressed: {
    text: WHITE,
    border: '#185037',
    background: '#185037'
  },
  active: {
    text: WHITE,
    border: '#185037',
    background: '#185037'
  },
  focus: {
    text: WHITE,
    border: FOCUS_BORDER_COLOR,
    background: '#28865E'
  },
  outlined: {
    text: '#28865E',
    border: '#28865E',
    background: WHITE
  },
  ghost: {
    text: '#28865E',
    border: TRANSPARENT,
    background: TRANSPARENT
  }
};
var dangerColor = {
  "default": {
    text: WHITE,
    border: '#DE2F1B',
    background: '#DE2F1B'
  },
  hover: {
    text: WHITE,
    border: '#C72918',
    background: '#C72918'
  },
  pressed: {
    text: WHITE,
    border: '#9B2012',
    background: '#9B2012'
  },
  active: {
    text: WHITE,
    border: '#9B2012',
    background: '#9B2012'
  },
  focus: {
    text: WHITE,
    border: FOCUS_BORDER_COLOR,
    background: '#DE2F1B'
  },
  outlined: {
    text: '#DE2F1B',
    border: '#DE2F1B',
    background: WHITE
  },
  ghost: {
    text: '#DE2F1B',
    border: TRANSPARENT,
    background: TRANSPARENT
  }
};
var lightColor = {
  "default": {
    text: DARK_TEXT,
    border: LIGHT_BG,
    background: LIGHT_BG
  },
  hover: {
    text: DARK_TEXT,
    border: LIGHT_BORDER,
    background: LIGHT_BORDER
  },
  pressed: {
    text: WHITE,
    border: LIGHT_BG,
    background: LIGHT_BG
  },
  active: {
    text: WHITE,
    border: '#575D67',
    background: '#575D67'
  },
  focus: {
    text: DARK_TEXT,
    border: FOCUS_BORDER_COLOR,
    background: LIGHT_BG
  },
  outlined: whiteOutlined,
  ghost: whiteGhost
};
var primaryColor = {
  "default": {
    text: WHITE,
    border: '#0077CC',
    background: '#0077CC'
  },
  hover: {
    text: WHITE,
    border: '#005999',
    background: '#005999'
  },
  pressed: {
    text: WHITE,
    border: '#004A7F',
    background: '#004A7F'
  },
  active: {
    text: WHITE,
    border: '#004A7F',
    background: '#004A7F'
  },
  focus: {
    text: WHITE,
    border: FOCUS_BORDER_COLOR,
    background: '#0077CC'
  },
  outlined: {
    text: '#0077CC',
    border: '#0077CC',
    background: WHITE
  },
  ghost: {
    text: '#0077CC',
    border: TRANSPARENT,
    background: TRANSPARENT
  }
};
var secondaryColor = {
  "default": {
    text: WHITE,
    border: '#5C5C5C',
    background: '#5C5C5C'
  },
  hover: {
    text: WHITE,
    border: '#575c66',
    background: '#5c626d'
  },
  pressed: {
    text: WHITE,
    border: '#575c66',
    background: '#5c626d'
  },
  active: {
    text: WHITE,
    border: '#575c66',
    background: '#5c626d'
  },
  focus: {
    text: WHITE,
    border: FOCUS_BORDER_COLOR,
    background: '#5C5C5C'
  },
  outlined: {
    text: '#5C5C5C',
    border: '#5C5C5C',
    background: WHITE
  },
  ghost: {
    text: '#5C5C5C',
    border: TRANSPARENT,
    background: TRANSPARENT
  }
};
var outlineColor = {
  "default": {
    text: DARK_TEXT,
    border: LIGHT_BORDER,
    background: WHITE
  },
  hover: {
    text: DARK_TEXT,
    border: LIGHT_BORDER,
    background: '#F6F8FA'
  },
  active: {
    text: DARK_TEXT,
    border: LIGHT_BORDER,
    background: LIGHT_BORDER
  },
  focus: {
    text: DARK_TEXT,
    border: FOCUS_BORDER_COLOR,
    background: WHITE
  },
  disabled: {
    text: LIGHT_BORDER,
    border: LIGHT_BG,
    background: WHITE
  }
};
var iconPrimaryColor = {
  "default": {
    text: WHITE,
    border: '#0095FF',
    background: '#0095FF'
  },
  hover: {
    text: WHITE,
    border: '#0077CC',
    background: '#0077CC'
  },
  active: {
    text: WHITE,
    border: '#005999',
    background: '#005999'
  },
  focus: {
    text: WHITE,
    border: '#002C4C',
    background: '#0095FF'
  },
  disabled: {
    text: WHITE,
    border: '#E5F4FF',
    background: '#E5F4FF'
  },
  outlined: {
    text: '#0095FF',
    border: '#0095FF',
    background: WHITE
  }
};
var iconOutlineColor = {
  "default": {
    text: '#767676',
    border: LIGHT_BG,
    background: WHITE
  },
  hover: {
    text: '#767676',
    border: LIGHT_BORDER,
    background: '#F0F2F6'
  },
  active: {
    text: '#767676',
    border: LIGHT_BORDER,
    background: LIGHT_BORDER
  },
  focus: {
    text: '#767676',
    border: '#333333',
    background: WHITE
  },
  disabled: {
    text: LIGHT_BORDER,
    border: LIGHT_BG,
    background: WHITE
  }
};
var buttonColors = exports.buttonColors = {
  primary: primaryColor,
  success: successColor,
  danger: dangerColor,
  secondary: secondaryColor,
  light: lightColor,
  destructive: {
    "default": dangerColor["default"],
    hover: dangerColor.hover,
    active: dangerColor.active,
    focus: dangerColor.focus,
    outlined: dangerColor.outlined
  },
  outline: outlineColor
};
var iconColors = exports.iconColors = {
  primary: iconPrimaryColor,
  destructive: {
    "default": dangerColor["default"],
    hover: dangerColor.hover,
    active: dangerColor.active,
    focus: _objectSpread(_objectSpread({}, dangerColor.focus), {}, {
      border: '#58120A'
    }),
    disabled: {
      text: WHITE,
      border: '#FBEAE8',
      background: '#FBEAE8'
    },
    outlined: dangerColor.outlined
  },
  light: {
    "default": lightColor["default"],
    hover: lightColor.hover,
    pressed: lightColor.pressed,
    active: lightColor.active,
    focus: _objectSpread(_objectSpread({}, lightColor.focus), {}, {
      border: '#575D67',
      background: '#575D67'
    }),
    outlined: lightColor.outlined,
    ghost: lightColor.ghost
  },
  outline: iconOutlineColor,
  success: successColor
};